<template>
	<div class="animated fadeIn">
		<b-row class="justify-content-between">
			<b-col md="8" lg="8">
				<div id="myMap" class="map-container"></div>
			</b-col>
			<b-col md="4" lg="4" class="m-lg-0 m-md-0 mt-sm-3 mt-3">
				<b-row>
					<b-col md="12" lg="12">
						<div class="card card-accent-info">
							<div class="card-header bg-white d-flex justify-content-between">
								<h5 class="card-title m-0">Casos</h5>
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</div>
							<div class="card-body d-flex flex-column justify-content-around align-items-start">
								<div class="d-flex justify-content-between w-100 border-bottom border-light">
									<span class="font-weight-bold">Activos (En Proceso)</span>
									<span class="font-weight-bold">{{incidentInProcess}}</span>
								</div>
								<div class="d-flex justify-content-between w-100 border-bottom border-light mt-2">
									<span class="font-weight-bold">Finalizados</span>
									<span class="font-weight-bold">{{incidentsTotalClosed}}</span>
								</div>
							</div>
						</div>
					</b-col>

					<b-col md="12" lg="12">
						<div class="card card-accent-info">
							<div class="card-header bg-white d-flex justify-content-between">
								<h5 class="card-title m-0">Tickets</h5>
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</div>
							<div class="card-body d-flex flex-column justify-content-around align-items-start">
								<div class="d-flex justify-content-between w-100 border-bottom border-light">
									<span class="font-weight-bold">Atendidos</span>
									<span class="font-weight-bold">50</span>
								</div>
								<div class="d-flex justify-content-between w-100 border-bottom border-light mt-2">
									<span class="font-weight-bold">Pendientes de Atender</span>
									<span class="font-weight-bold">50</span>
								</div>
							</div>
						</div>
					</b-col>

					<b-col md="12" lg="12">
						<div class="card card-accent-info">
							<div class="card-header bg-white d-flex justify-content-between">
								<h5 class="card-title m-0">Facturas</h5>
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</div>
							<div class="card-body d-flex flex-column justify-content-around align-items-start">
								<div class="d-flex justify-content-between w-100 border-bottom border-light mt-2">
									<span class="font-weight-bold">Pendientes de Pago</span>
									<span class="font-weight-bold">50</span>
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueBingMaps from 'vue-bing-maps'
	import {mapActions} from "vuex";

	Vue.use(VueBingMaps);

	export default {
		name: "MainDashboard",
		data: function () {
			return {
				loading: false,
				accounts: [],
				mapCredentials: 'AgO-p0GZ90FB-ursWM87EuaFOiD4FM1QmfLdUWMPPR8eOi_ceowtbyo4BcigUieT',
				incidentInProcess: 0,
				incidentsTotalClosed: 0
			}
		},
		mounted() {
			this.loading = true;
			var that = this;

			delete window['getMap'];

			window['getMap'] = function () {
				var map = new Microsoft.Maps.Map('#myMap', {
					zoom: 8
				});

				var infobox = new Microsoft.Maps.Infobox(map.getCenter(), {
					visible: false
				});
				var clusterLayer;

				var pinsList = [];


				infobox.setMap(map);

				that.accounts.map(function (account) {
					let pin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(Number(account.Latitude), Number(account.Longitude)), {
						title: account.IncidentSummary.InProcessCount + ' Casos Activos'
					});

					pin.metadata = {
						title: account.Alias,
						description: account.Number
					};

					Microsoft.Maps.Events.addHandler(pin, 'click', pushpinClicked);
					pinsList.push(pin);
					// map.entities.push(pin);
				});

				Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function () {
					clusterLayer = new Microsoft.Maps.ClusterLayer(pinsList);
					map.layers.insert(clusterLayer);
				});

				function pushpinClicked(e) {
					if (e.target.metadata) {
						infobox.setOptions({
							location: e.target.getLocation(),
							title: e.target.metadata.title,
							description: e.target.metadata.description,
							visible: true
						});
					}
				}
			}


			let tag = document.createElement('script');
			tag.type = 'text/javascript';
			tag.src = "https://www.bing.com/api/maps/mapcontrol?callback=getMap&key=AgO-p0GZ90FB-ursWM87EuaFOiD4FM1QmfLdUWMPPR8eOi_ceowtbyo4BcigUieT";
			tag.async = true;
			tag.defer = true;

			document.head.append(tag);

			this.getDashboardInfo()
				.then((response) => {
					console.log(response);
					this.incidentInProcess = response.incidentTotalInProcess;
					this.incidentsTotalClosed = response.incidentsTotalClosed;
					this.accounts = response.accounts;
					getMap();
				})
				.catch((err) => {
					this.loading = false;
					console.log(err.response);
				})
				.finally(() => {
					this.loading = false;
				})
		},
		methods: {
			...mapActions([
				'getDashboardInfo'
			])
		}
	}
</script>

<style scoped>
	.map-container {
		width: 100%;
		height: 77vh;
	}
</style>
